var exports = {
  "jw": "SearchFilterChip.module__chip___TC1sYU",
  "xA": "SearchFilterChip.module__chipActive___TC1sYU",
  "mD": "SearchFilterChip.module__chipIcon___TC1sYU",
  "s5": "SearchFilterChip.module__chipContent___TC1sYU",
  "Zl": "SearchFilterChip.module__chipLabel___TC1sYU",
  "$j": "SearchFilterChip.module__chipLabelActive___TC1sYU",
  "ET": "SearchFilterChip.module__chipValue___TC1sYU",
  "cG": "SearchFilterChip.module__chipValueActive___TC1sYU",
  "DT": "SearchFilterChip.module__removeButton___TC1sYU",
};

module.exports = exports;
